import { HttpClient, HttpResponse } from '@wix/http-client';

const httpClient = new HttpClient();

async function wixResultInterceptor(
  response: HttpResponse,
): Promise<HttpResponse> {
  // Handling deprecated convention in premium-store response
  if (!response.data) {
    return response;
  }

  if (response.data.success === false) {
    response.status = 500;
    return Promise.reject(response);
  }

  if (response.data.success === true && response.data.payload !== undefined) {
    const payload = response.data.payload;
    if (typeof payload === 'object' && !Array.isArray(payload)) {
      delete response.data.payload;
      delete response.data.success;
      delete response.data.errorCode;
      delete response.data.errorDescription;
      response.data = { ...response.data, ...payload };
    } else {
      response.data = response.data.payload;
    }
  }

  return response;
}

async function validateResponse(response: HttpResponse) {
  const validatedResponse = await wixResultInterceptor(response);
  return validatedResponse.data;
}

async function get<R>(url: string): Promise<R> {
  const response = await httpClient.get(url);
  return validateResponse(response);
}

async function post<P, R>(url: string, params: P): Promise<R> {
  const response = await httpClient.post(url, params);
  return validateResponse(response);
}

export const ApiManager = {
  get,
  post,
};
